<template>
  <div class="duplicate-step2">
    <!-- Header bar - matching deliverable page style -->
    <div class="header-controls" id="dup__header__controls">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6 d-flex align-items-center mt-1">
            <button class="btn btn-primary select-btn mr-2" @click.prevent="selectAll">All</button>
            <button class="btn btn-primary select-btn mr-3" @click.prevent="clearAll">None</button>
            <!-- <span class="dup-selected-count">
              {{ selectedCount }} / {{ totalCount }}
            </span> -->

            <b-form-checkbox v-model="options.taskUsers" :disabled="totalCount === 0" class="dup-action-link mr-3">Copy Task Users</b-form-checkbox>
            <b-form-checkbox v-model="options.taskNotes" :disabled="totalCount === 0" class="dup-action-link mr-3">Copy Task Notes</b-form-checkbox>
          </div>
          <div class="col-6">
            <div class="form-inline filters-form">
              <div class="input-group top-search" style="margin: 0 .5rem 0 0!important;">
                <input
                  type="text"
                  class="form-control media-calls-search"
                  v-model="searchQuery"
                  placeholder="Search Deliverables..."
                  id="dup-search-query"
                />
                <div class="input-group-append cursor-pointer">
                  <span class="input-group-text">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
              <b-button
                ref="filterBoxBtn"
                id="dup-popover-filter-btn"
                class="ml-2 header-filter-btns"
                style="margin: 0!important;"
                variant="theme"
                tabindex="0"
                href="#"
                @keydown.esc="$refs.dupFilterPopover.$emit('close')"
              >
                <span class="wider-filter-only">Filter</span>
                <img src="/images/filter.svg" />
              </b-button>
              <b-popover
                triggers="click blur"
                boundary="window"
                placement="bottom"
                ref="dupFilterPopover"
                target="dup-popover-filter-btn"
                custom-class="deliverable-filter"
              >
                <div class="d-flex flex-row">
                  <div class="filter-item item__status">
                    <label>Task Status</label>
                    <div v-if="!isMobile()" class="status-wrap">
                      <a
                        href="#"
                        @click="setStatusFilter(s)"
                        class="badge mr-2"
                        :style="{color: 'var(--wf-secondary)', backgroundColor: s.color}"
                        v-for="(s, index) in statuses"
                        :key="index"
                      >{{ s.name }}</a>
                    </div>
                    <div class="custom-field status-field">
                      <multiselect
                        v-if="isMobile()"
                        :searchable="true"
                        v-model="filterQuery.status"
                        label="name"
                        :options="statuses"
                        placeholder="Select status"
                        :show-labels="false"
                        :multiple="true"
                        :hide-selected="true"
                      >
                        <template slot="option" slot-scope="props">
                          <div
                            :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }"
                          >{{ props.option.name }}</div>
                        </template>
                        <template slot="tag" slot-scope="props">
                          <div
                            :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, textAlign: 'center', display: 'inline-block', padding: '5px 10px', marginRight: '5px' }"
                          >{{ props.option.name }}</div>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div class="grouped-filter-item">
                    <div class="filter-item item__outlet">
                      <div>
                        <label>Outlet</label>
                        <b-form-checkbox
                          v-if="isMobile()"
                          class="float-right csm-checkbox"
                          v-model="filterQuery.noOutlet"
                          id="dup-no-outlet"
                          name="dup-no-outlet"
                          value="accepted"
                          unchecked-value="not_accepted"
                          @input="filterQuery.noOutlet == 'accepted' ? filterQuery.outlet = [] : ''"
                        >No Outlet</b-form-checkbox>
                      </div>
                      <div class="outlet-wrap">
                        <multiselect
                          ref="outletFilter"
                          v-model="filterQuery.outlet"
                          track-by="id"
                          open-direction="bottom"
                          label="name"
                          :options="contacts"
                          :show-labels="false"
                          :multiple="true"
                          :close-on-select="false"
                          :hide-selected="true"
                          :preserve-search="true"
                          :clear-on-select="false"
                          :internal-search="false"
                          :loading="isContactsLoading"
                          @select="filterQuery.noOutlet='not_accepted'"
                          @search-change="onWhoSearch"
                        >
                          <template slot="selection" slot-scope="{ values, search, isOpen }">
                            <span
                              class="multiselect__single"
                              v-if="values.length && !isOpen"
                            >{{ values.length }} options selected</span>
                          </template>
                          <template slot="option" slot-scope="props">
                            <div class="option__desc">
                              <span class="option__title">{{ props.option.name }}</span>
                              <br />
                              <span class="option__small text-muted">{{ props.option.company_name }}</span>
                            </div>
                          </template>
                          <template slot="noOptions">Start typing to find contacts.</template>
                          <template slot="noResult">No results. Please try changing the search query.</template>
                        </multiselect>
                      </div>
                      <b-form-checkbox
                        v-if="!isMobile()"
                        class="mt-2 csm-checkbox"
                        v-model="filterQuery.noOutlet"
                        id="dup-no-outlet-desktop"
                        name="dup-no-outlet-desktop"
                        value="accepted"
                        unchecked-value="not_accepted"
                        @input="filterQuery.noOutlet == 'accepted' ? filterQuery.outlet = [] : ''"
                      >No Outlet</b-form-checkbox>
                    </div>
                    <div class="filter-item item__coordinator">
                      <label>Coordinator</label>
                      <div class="coordinator-wrap">
                        <multiselect
                          ref="coordinatorFilter"
                          v-model="filterQuery.coordinator"
                          :options="allActiveUsers"
                          :show-labels="false"
                          :multiple="true"
                          open-direction="bottom"
                          label="name"
                          track-by="id"
                          :hide-selected="false"
                          :close-on-select="false"
                          :clear-on-select="false"
                        >
                          <template slot="selection" slot-scope="{ values, search, isOpen }">
                            <span
                              class="multiselect__single"
                              v-if="values.length && !isOpen"
                            >{{ values.length }} options selected</span>
                          </template>
                        </multiselect>
                      </div>
                    </div>
                    <div class="filter-item item__deliverable__type">
                      <label>Deliverable Type</label>
                      <div class="deliverable-type-wrap">
                        <multiselect
                          ref="deliverableTypeFilter"
                          v-model="filterQuery.deliverableType"
                          :options="deliverableTypeOptions"
                          :show-labels="false"
                          :multiple="true"
                          open-direction="bottom"
                          label="name"
                          track-by="id"
                          :hide-selected="false"
                          :close-on-select="false"
                          :clear-on-select="false"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="grouped-filter-item">
                    <div class="filter-item item__department">
                      <div>
                        <label>Department</label>
                        <b-form-checkbox
                          v-if="isMobile()"
                          class="float-right csm-checkbox"
                          v-model="filterQuery.noDepartment"
                          id="dup-no-department"
                          name="dup-no-department"
                          value="accepted"
                          unchecked-value="not_accepted"
                          @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''"
                        >No Department</b-form-checkbox>
                      </div>
                      <div class="tag-wrap">
                        <multiselect
                          ref="departmentFilter"
                          v-model="filterQuery.department"
                          open-direction="bottom"
                          label="name"
                          track-by="id"
                          :options="departments"
                          :hide-selected="false"
                          :show-labels="false"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          @select="filterQuery.noDepartment = 'not_accepted'"
                        >
                          <template slot="selection" slot-scope="{ values, search, isOpen }">
                            <span
                              class="multiselect__single"
                              v-if="values.length && !isOpen"
                            >{{ values.length }} options selected</span>
                          </template>
                          <template slot="noOptions">Start typing to find departments.</template>
                          <template slot="noResult">No results. Please try changing the search query.</template>
                        </multiselect>
                      </div>
                      <b-form-checkbox
                        v-if="!isMobile()"
                        class="mt-2 csm-checkbox"
                        v-model="filterQuery.noDepartment"
                        id="dup-no-department-desktop"
                        name="dup-no-department-desktop"
                        value="accepted"
                        unchecked-value="not_accepted"
                        @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''"
                      >No Department</b-form-checkbox>
                    </div>
                    <div class="filter-item item__tag">
                      <label>Tag</label>
                      <div class="tag-wrap">
                        <multiselect
                          ref="tagFilter"
                          v-model="filterQuery.tag"
                          :options="tags"
                          :show-labels="false"
                          :multiple="true"
                          open-direction="bottom"
                          label="name"
                          track-by="id"
                          :hide-selected="false"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :loading="isTagsLoading"
                          :preserve-search="true"
                          @search-change="onTagSearch"
                        >
                          <template slot="selection" slot-scope="{ values, search, isOpen }">
                            <span
                              class="multiselect__single"
                              v-if="values.length && !isOpen"
                            >{{ values.length }} options selected</span>
                          </template>
                          <template slot="noOptions">Start typing to find tags.</template>
                          <template slot="noResult">No results. Please try changing the search query.</template>
                        </multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="filter-item item__date">
                    <div class="due__created__dates">
                      <div>
                        <label>Due Date</label>
                        <br />
                        <date-range-picker
                          ref="picker"
                          @update="onUpdateDueDate"
                          :autoApply="true"
                          :ranges="customDueDateRanges"
                          v-model="filterQuery.dateRange"
                        ></date-range-picker>
                      </div>
                      <div>
                        <label class="mt-2">Created</label>
                        <br />
                        <date-range-picker
                          ref="pickerDateCreated"
                          @update="onUpdateDateCreated"
                          :autoApply="true"
                          :ranges="customCreatedDateRanges"
                          v-model="filterQuery.dateCreatedRange"
                        ></date-range-picker>
                      </div>
                    </div>
                    <div>
                      <label class="mt-lg-2">Completed</label>
                      <br />
                      <date-range-picker
                        ref="pickerDateCompleted"
                        @update="onUpdateDateCompleted"
                        :autoApply="true"
                        :ranges="customCompletedDateRanges"
                        v-model="filterQuery.dateCompletedRange"
                      ></date-range-picker>
                    </div>
                  </div>
                  <div class="filter-item item__priority filter-item-no-border">
                    <div class="priority__filter">
                      <label>Priority</label>
                      <br />
                      <div @click="setPriority" class="filter-rating">
                        <vue-star-rate
                          :rateRange="filterQuery.priorityFilter"
                          :maxIcon="5"
                          :iconHeight="17"
                          :iconWidth="17"
                          :hasCounter="false"
                          iconColor="var(--wf-primary)"
                          iconColorHover="var(--wf-primary)"
                          iconShape="circle"
                        ></vue-star-rate>
                      </div>
                    </div>
                    <div class="priority__sort">
                      <label class="mt-2">Sort by Priority</label>
                      <br>
                      <div class="btn-group add-new__global_search sorting main__filter">
                        <button
                          class="btn btn-theme header-filter-btns dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Sort
                          <i class="fas fa-sort text-primary float-right"></i>
                        </button>
                        <div class="dropdown-menu">
                          <a class="dropdown-item" @click="setSort('priorityDesc')" href="#">Priority Decending</a>
                          <a class="dropdown-item" @click="setSort('priorityAsc')" href="#">Priority Ascending</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="item__reset">
                      <b-button variant="theme" title="Reset All Filter" size="sm" @click="resetFilter"><i class="fas fa-undo"></i></b-button>
                      <b-button class="d-block d-lg-none" variant="theme" title="Close Filter Popup" size="sm" @click="$refs.dupFilterPopover.$emit('close')"><i class="fas fa-times"></i></b-button>
                    </div>
                  </div>
                </div>
                <!-- Active filter badges inside popover (desktop) -->
                <div
                  class="d-none d-md-block mt-3 test1"
                  v-if="hasActiveFilters"
                >
                  <label>Click to remove filters:</label>
                  <br />
                  <span
                    v-if="filterQuery.query"
                    class="badge badge-primary mr-2 mb-2"
                    @click="filterQuery.query = null; searchQuery = ''"
                    :style="{cursor: 'pointer'}"
                  >{{ filterQuery.query }}</span>
                  <span
                    class="badge mr-2 mb-2"
                    @click="removeFilter(status)"
                    :style="{cursor: 'pointer', color: 'var(--wf-secondary)', backgroundColor: status.color}"
                    v-for="status in filterQuery.status"
                    :key="'fs-' + status.name"
                  >{{ status.name }}</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="removeFilter(outlet)"
                    :style="{cursor: 'pointer'}"
                    v-for="outlet in filterQuery.outlet"
                    :key="'fo-' + outlet.id"
                  >{{ outlet.name }}</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="removeFilter(deliverableType)"
                    :style="{cursor: 'pointer'}"
                    v-for="deliverableType in filterQuery.deliverableType"
                    :key="'fdt-' + deliverableType.id"
                  >{{ deliverableType.name }}</span>
                  <span
                    v-if="filterQuery.priorityFilter > 0"
                    class="badge badge-primary mr-2 mb-2"
                    @click="removeFilter('resetPriorityFilter')"
                    :style="{cursor: 'pointer'}"
                  >Priority {{ filterQuery.priorityFilter }}</span>
                  <span
                    v-if="filterQuery.sort"
                    class="badge mr-2 mb-2 bg-primary cursor-pointer"
                    style="color: var(--wf-secondary);"
                    @click="removeFilter('resetDeliverableSort')"
                  >{{ filterQuery.sort == 'priorityDesc' ? 'Priority Descending' : 'Priority Ascending' }}</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="removeFilter(coordinator)"
                    :style="{cursor: 'pointer'}"
                    v-for="coordinator in filterQuery.coordinator"
                    :key="'fc-' + coordinator.id"
                  >{{ coordinator.name }}</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="removeFilter('filterByDate')"
                    :style="{cursor: 'pointer'}"
                    v-if="filterQuery.filterByDate"
                  >Due Date: {{ filterQuery.dateRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateRange.endDate | moment('MMM DD') }}</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="filterQuery.filterNoDueDate=false"
                    :style="{cursor: 'pointer'}"
                    v-if="filterQuery.filterNoDueDate"
                  >No Due Date</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="removeFilter('filterByDateCreated')"
                    :style="{cursor: 'pointer'}"
                    v-if="filterQuery.filterByDateCreated"
                  >Created: {{ filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="removeFilter('filterByDateCompleted')"
                    :style="{cursor: 'pointer'}"
                    v-if="filterQuery.filterByDateCompleted"
                  >Completed: {{ filterQuery.dateCompletedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCompletedRange.endDate | moment('MMM DD') }}</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="removeFilter(tag)"
                    :style="{cursor: 'pointer'}"
                    v-for="tag in filterQuery.tag"
                    :key="'ft-' + tag.id"
                  >{{ tag.name }}</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="removeFilter(department)"
                    :style="{cursor: 'pointer'}"
                    v-for="department in filterQuery.department"
                    :key="'fd-' + department.id"
                  >{{ department.name }}</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="filterQuery.noDepartment='not_accepted'"
                    :style="{cursor: 'pointer'}"
                    v-if="filterQuery.noDepartment == 'accepted'"
                  >No Department</span>
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="filterQuery.noOutlet='not_accepted'"
                    :style="{cursor: 'pointer'}"
                    v-if="filterQuery.noOutlet == 'accepted'"
                  >No Outlet</span>
                </div>
              </b-popover>
              <div class="ml-2 expand-grp cursor-pointer wider-filter-only" style="margin: 0 0 0 .5rem!important;">
                <button
                  class="btn header-filter-btns expand-ctrls btn-theme"
                  :class="{ 'none-active-btn': expandAll }"
                  :disabled="expandingAll"
                  @click="expandAllItems"
                  title="Expand"
                >
                  <span class="text">{{ expandingAll ? 'Loading...' : 'Expand All' }}</span>
                  <span class="icon"><i class="fas text-primary fa-expand fa-fw"></i></span>
                </button>
                <button
                  class="btn header-filter-btns expand-ctrls btn-theme"
                  :class="{ 'none-active-btn': !expandAll }"
                  @click="collapseAllItems"
                  title="Collapse"
                >
                  <span class="text">Collapse All</span>
                  <span class="icon"><i class="fas text-primary fa-compress fa-fw"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Active filter badges below header (mobile + desktop) -->
    <div class="filter-badges d-md-none px-3 py-2" v-if="hasActiveFilters">
      <span
        class="badge mr-2 mb-2"
        @click="removeFilter(status)"
        :style="{cursor: 'pointer', color: 'var(--wf-secondary)', backgroundColor: status.color}"
        v-for="status in filterQuery.status"
        :key="'fms-' + status.name"
      >{{ status.name }}</span>
      <span
        class="badge badge-primary mr-2 mb-2"
        @click="removeFilter(outlet)"
        :style="{cursor: 'pointer'}"
        v-for="outlet in filterQuery.outlet"
        :key="'fmo-' + outlet.id"
      >{{ outlet.name }}</span>
      <span
        class="badge badge-primary mr-2 mb-2"
        @click="removeFilter(deliverableType)"
        :style="{cursor: 'pointer'}"
        v-for="deliverableType in filterQuery.deliverableType"
        :key="'fmdt-' + deliverableType.id"
      >{{ deliverableType.name }}</span>
      <span
        class="badge badge-primary mr-2 mb-2"
        @click="removeFilter(coordinator)"
        :style="{cursor: 'pointer'}"
        v-for="coordinator in filterQuery.coordinator"
        :key="'fmc-' + coordinator.id"
      >{{ coordinator.name }}</span>
      <span
        class="badge badge-primary mr-2 mb-2"
        @click="removeFilter(tag)"
        :style="{cursor: 'pointer'}"
        v-for="tag in filterQuery.tag"
        :key="'fmt-' + tag.id"
      >{{ tag.name }}</span>
      <span
        class="badge badge-primary mr-2 mb-2"
        @click="removeFilter(department)"
        :style="{cursor: 'pointer'}"
        v-for="department in filterQuery.department"
        :key="'fmd-' + department.id"
      >{{ department.name }}</span>
      <span
        v-if="filterQuery.noDepartment == 'accepted'"
        class="badge badge-primary mr-2 mb-2"
        @click="filterQuery.noDepartment='not_accepted'"
        :style="{cursor: 'pointer'}"
      >No Department</span>
      <span
        v-if="filterQuery.noOutlet == 'accepted'"
        class="badge badge-primary mr-2 mb-2"
        @click="filterQuery.noOutlet='not_accepted'"
        :style="{cursor: 'pointer'}"
      >No Outlet</span>
    </div>

    <!-- Loading state -->
    <div v-if="loading" class="text-center p-5">
      <b-spinner label="Loading..."></b-spinner>
      <p class="mt-2">Loading deliverables...</p>
    </div>

    <!-- Empty state -->
    <div v-else-if="allDeliverables.length === 0" class="text-center p-5">
      <p class="text-muted">No deliverables available for duplication.</p>
    </div>

    <!-- Deliverable list - using add-project-deliverable-tab UI -->
    <div v-else class="tab-content add-project-deliverable-tab">
      <div class="project--deliverable--tab-content">
        <div id="deliverable__in__project__list__dup" style="padding: 1rem 50px 0 50px">
          <div v-if="filteredDeliverables.length === 0" class="text-center p-4">
            <p class="text-muted">No deliverables match your filter.</p>
          </div>
          <DuplicateDeliverableListItem
            v-for="deliverable in filteredDeliverables"
            :key="'dup-del-' + deliverable.id"
            :deliverable="deliverable"
            :forceExpand="expandAll"
            @open-post-selection="openPostSelectionModal"
            @open-deliverable-detail="openDeliverableDetailModal"
          />
        </div>
      </div>
    </div>

    <!-- Post Selection Modal -->
    <DuplicatePostSelectionModal
      v-if="activePostDeliverable"
      :deliverable="activePostDeliverable"
      :visible="showPostModal"
      @close="closePostSelectionModal"
    />

    <DuplicateDeliverableDetailModal :deliverable="activePreviewDeliverable" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import DuplicateDeliverableListItem from "./DuplicateDeliverableListItem.vue";
import DuplicatePostSelectionModal from "./DuplicatePostSelectionModal.vue";
import DuplicateDeliverableDetailModal from "./DuplicateDeliverableDetailModal.vue";
import vueStarRate from "vue-js-star-rating";

export default {
  name: "DuplicateStep2SelectDeliverables",
  components: {
    DuplicateDeliverableListItem,
    DuplicatePostSelectionModal,
    DuplicateDeliverableDetailModal,
    vueStarRate,
  },
  data() {
    return {
      searchQuery: "",
      loading: false,
      expandAll: false,
      expandingAll: false,
      showPostModal: false,
      activePostDeliverable: null,
      activePreviewDeliverable: null,
      contacts: [],
      tags: [],
      departments: [],
      isContactsLoading: false,
      isTagsLoading: false,
      isDepartmentsLoading: false,
      filterQuery: {
        sort: "",
        query: "",
        filterByDate: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        status: [],
        outlet: [],
        deliverableType: [],
        tag: [],
        department: [],
        coordinator: [],
        noDepartment: "not_accepted",
        noOutlet: "not_accepted",
        filterNoDueDate: false,
        filterByDateCreated: false,
        filterByDateCompleted: false,
        priorityFilter: 0,
      },
      customDueDateRanges: {
        "No Due Date": [null, null],
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
        "Next week": [
          this.$moment().startOf("week").add(7, "days").toDate(),
          this.$moment().endOf("week").add(7, "days").toDate(),
        ],
        "Next two weeks": [
          this.$moment().startOf("week").add(7, "days").toDate(),
          this.$moment().endOf("week").add(14, "days").toDate(),
        ],
      },
      customCreatedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      customCompletedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
    };
  },
  computed: {
    ...mapState({
      duplicationWizard: (state) => state.duplicationWizard,
    }),
    ...mapGetters([
      "selectedDeliverableCount",
      "allActiveUsers",
      "allCustomFields",
    ]),
    allDeliverables() {
      return this.duplicationWizard.allDeliverables || [];
    },
    options() {
      return this.duplicationWizard.projectOptions;
    },
    selectedCount() {
      return this.selectedDeliverableCount;
    },
    totalCount() {
      return this.allDeliverables.length;
    },
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function (item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
      return [];
    },
    deliverableTypeOptions() {
      const typeMap = {};
      this.allDeliverables.forEach((d) => {
        if (d.deliverable_template_id && d.template_title) {
          typeMap[d.deliverable_template_id] = {
            id: d.deliverable_template_id,
            name: d.template_title,
          };
        }
      });
      return Object.values(typeMap).sort((a, b) => a.name.localeCompare(b.name));
    },
    hasActiveFilters() {
      return (
        this.filterQuery.noDepartment == "accepted" ||
        this.filterQuery.noOutlet == "accepted" ||
        this.filterQuery.filterNoDueDate ||
        this.filterQuery.query ||
        this.filterQuery.status.length ||
        this.filterQuery.filterByDate ||
        this.filterQuery.filterByDateCreated ||
        this.filterQuery.filterByDateCompleted ||
        this.filterQuery.coordinator.length ||
        this.filterQuery.outlet.length ||
        this.filterQuery.deliverableType.length ||
        this.filterQuery.tag.length ||
        this.filterQuery.department.length ||
        this.filterQuery.sort ||
        this.filterQuery.priorityFilter > 0
      );
    },
    filteredDeliverables() {
      let list = this.allDeliverables;

      // Text search
      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase();
        list = list.filter((d) => {
          if (d.title && d.title.toLowerCase().includes(q)) return true;
          if (d.departments && d.departments.some((dept) => dept.name && dept.name.toLowerCase().includes(q))) return true;
          if (d.template_title && d.template_title.toLowerCase().includes(q)) return true;
          return false;
        });
      }

      // Status filter — deliverables that have at least one task with matching status
      if (this.filterQuery.status.length) {
        const statusNames = this.filterQuery.status.map((s) => s.name);
        list = list.filter((d) => {
          if (!d.tasks || !d.tasks.length) return false;
          return d.tasks.some((t) => statusNames.includes(t.status_name));
        });
      }

      // Outlet filter
      if (this.filterQuery.outlet.length) {
        const outletIds = this.filterQuery.outlet.map((o) => o.id);
        list = list.filter((d) => {
          if (!d.outlets || !d.outlets.length) return false;
          return d.outlets.some((o) => outletIds.includes(o.contact_id));
        });
      }

      // No Outlet
      if (this.filterQuery.noOutlet == "accepted") {
        list = list.filter((d) => !d.outlets || d.outlets.length === 0);
      }

      // Coordinator filter
      if (this.filterQuery.coordinator.length) {
        const coordIds = this.filterQuery.coordinator.map((c) => c.id);
        list = list.filter((d) => coordIds.includes(d.coordinator_id));
      }

      // Deliverable Type filter
      if (this.filterQuery.deliverableType.length) {
        const typeIds = this.filterQuery.deliverableType.map((t) => t.id);
        list = list.filter((d) => typeIds.includes(d.deliverable_template_id));
      }

      // Department filter
      if (this.filterQuery.department.length) {
        const deptIds = this.filterQuery.department.map((dept) => dept.id);
        list = list.filter((d) => {
          if (!d.departments || !d.departments.length) return false;
          return d.departments.some((dept) => deptIds.includes(dept.department_id));
        });
      }

      // No Department
      if (this.filterQuery.noDepartment == "accepted") {
        list = list.filter((d) => !d.departments || d.departments.length === 0);
      }

      // Tag filter
      if (this.filterQuery.tag.length) {
        const tagIds = this.filterQuery.tag.map((t) => t.id);
        list = list.filter((d) => {
          if (!d.tags || !d.tags.length) return false;
          return d.tags.some((t) => tagIds.includes(t.tag_id));
        });
      }

      // Due Date filter (checks task due_dates)
      if (this.filterQuery.filterByDate) {
        const start = this.$moment(this.filterQuery.dateRange.startDate).startOf("day");
        const end = this.$moment(this.filterQuery.dateRange.endDate).endOf("day");
        list = list.filter((d) => {
          if (!d.tasks || !d.tasks.length) return false;
          return d.tasks.some((t) => {
            if (!t.due_date) return false;
            const dd = this.$moment(t.due_date);
            return dd.isBetween(start, end, null, "[]");
          });
        });
      }

      // No Due Date filter
      if (this.filterQuery.filterNoDueDate) {
        list = list.filter((d) => {
          if (!d.tasks || !d.tasks.length) return true;
          return d.tasks.every((t) => !t.due_date);
        });
      }

      // Created Date filter
      if (this.filterQuery.filterByDateCreated) {
        const start = this.$moment(this.filterQuery.dateCreatedRange.startDate).startOf("day");
        const end = this.$moment(this.filterQuery.dateCreatedRange.endDate).endOf("day");
        list = list.filter((d) => {
          if (!d.created_at) return false;
          const ca = this.$moment(d.created_at);
          return ca.isBetween(start, end, null, "[]");
        });
      }

      // Completed Date filter
      if (this.filterQuery.filterByDateCompleted) {
        const start = this.$moment(this.filterQuery.dateCompletedRange.startDate).startOf("day");
        const end = this.$moment(this.filterQuery.dateCompletedRange.endDate).endOf("day");
        list = list.filter((d) => {
          if (!d.completed_at) return false;
          const ca = this.$moment(d.completed_at);
          return ca.isBetween(start, end, null, "[]");
        });
      }

      // Priority filter
      if (this.filterQuery.priorityFilter > 0) {
        list = list.filter((d) => d.priority == this.filterQuery.priorityFilter);
      }

      // Priority sort
      if (this.filterQuery.sort === "priorityDesc") {
        list = [...list].sort((a, b) => (b.priority || 0) - (a.priority || 0));
      } else if (this.filterQuery.sort === "priorityAsc") {
        list = [...list].sort((a, b) => (a.priority || 0) - (b.priority || 0));
      }

      return list;
    },
  },
  async created() {
    if (!this.duplicationWizard.allDeliverablesLoaded) {
      const projectId = this.$route.params.projectId;
      if (projectId) {
        this.loading = true;
        try {
          await this.$store.dispatch("fetchAllDeliverableIdsForDuplication", projectId);
          this.$store.commit("SELECT_ALL_DELIVERABLES");
        } catch (e) {
          console.error("Failed to load deliverables for duplication:", e);
        }
        this.loading = false;
      }
    }
    // Load filter option data
    this.$store.dispatch("fetchAllCustomFields");
    this.onWhoSearch("");
    this.onTagSearch("");
    this.onDepartmentSearch("");
  },
  methods: {
    selectAll() {
      this.$store.commit("SELECT_ALL_DELIVERABLES");
    },
    clearAll() {
      this.$store.commit("CLEAR_ALL_DELIVERABLES");
    },
    openPostSelectionModal(deliverable) {
      this.activePostDeliverable = deliverable;
      this.showPostModal = true;
    },
    openDeliverableDetailModal(deliverable) {
      this.activePreviewDeliverable = deliverable;
      this.$nextTick(() => {
        this.$bvModal.show("duplicateDeliverableDetailModal");
      });
    },
    closePostSelectionModal() {
      this.showPostModal = false;
      this.activePostDeliverable = null;
    },
    async expandAllItems() {
      this.expandingAll = true;
      try {
        const missingPostDeliverableIds = this.filteredDeliverables
          .filter((deliverable) => (
            deliverable.template_slug === "organic-social-media-plan" &&
            deliverable.posts_count > 0 &&
            !deliverable.posts_loaded
          ))
          .map((deliverable) => deliverable.id);

        if (missingPostDeliverableIds.length > 0) {
          await this.$store.dispatch("fetchDuplicationSocialPostsBatch", missingPostDeliverableIds);
        }

        this.expandAll = true;
      } catch (error) {
        console.error("Failed to load social posts for expand all:", error);
      } finally {
        this.expandingAll = false;
      }
    },
    collapseAllItems() {
      this.expandAll = false;
    },
    focusFilterBtn() {
      if (this.$refs.filterBoxBtn) {
        this.$refs.filterBoxBtn.focus();
      }
    },
    setStatusFilter(status) {
      if (this.filterQuery.status.indexOf(status) != -1) {
        this.removeFilter(status);
      } else {
        this.filterQuery.status.push(status);
      }
    },
    removeFilter(data) {
      if (typeof data != "undefined") {
        if (typeof data == "string") {
          if (data == "resetPriorityFilter") {
            this.filterQuery.priorityFilter = 0;
            $(".filter-rating .vue-star-rate ul li").each(function () {
              $(this).removeClass("active");
            });
          }
          if (data == "resetDeliverableSort") {
            this.filterQuery.sort = "";
          }
          if (data == "deliverableType") {
            this.filterQuery.deliverableType = [];
          }
          if (data == "filterByDate") {
            this.filterQuery.filterByDate = false;
            this.filterQuery.dateRange.startDate = new Date();
            this.filterQuery.dateRange.endDate = new Date();
          }
          if (data == "filterByDateCreated") {
            this.filterQuery.filterByDateCreated = false;
            this.filterQuery.dateCreatedRange.startDate = new Date();
            this.filterQuery.dateCreatedRange.endDate = new Date();
          }
          if (data == "filterByDateCompleted") {
            this.filterQuery.filterByDateCompleted = false;
            this.filterQuery.dateCompletedRange.startDate = new Date();
            this.filterQuery.dateCompletedRange.endDate = new Date();
          }
        } else {
          this.filterQuery.deliverableType = this.filterQuery.deliverableType.filter(
            (s) => s.name != data.name
          );
          this.filterQuery.status = this.filterQuery.status.filter(
            (s) => s.name != data.name
          );
          this.filterQuery.coordinator = this.filterQuery.coordinator.filter(
            (s) => s.name != data.name
          );
          this.filterQuery.outlet = this.filterQuery.outlet.filter(
            (s) => s.name != data.name
          );
          this.filterQuery.tag = this.filterQuery.tag.filter(
            (s) => s.name != data.name
          );
          this.filterQuery.department = this.filterQuery.department.filter(
            (s) => s.name != data.name
          );
        }
      }
    },
    resetFilter() {
      this.filterQuery.filterNoDueDate = false;
      this.filterQuery.noDepartment = "not_accepted";
      this.filterQuery.noOutlet = "not_accepted";
      this.filterQuery.query = null;
      this.searchQuery = "";
      this.filterQuery.priorityFilter = 0;
      $(".filter-rating .vue-star-rate ul li").each(function () {
        $(this).removeClass("active");
      });
      this.filterQuery.filterByDate = false;
      this.filterQuery.dateRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
      this.filterQuery.filterByDateCreated = false;
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
      this.filterQuery.filterByDateCompleted = false;
      this.filterQuery.dateCompletedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
      this.filterQuery.status = [];
      this.filterQuery.outlet = [];
      this.filterQuery.deliverableType = [];
      this.filterQuery.tag = [];
      this.filterQuery.sort = "";
      this.filterQuery.coordinator = [];
      this.filterQuery.department = [];
    },
    onUpdateDueDate() {
      if (
        this.filterQuery.dateRange.startDate === null &&
        this.filterQuery.dateRange.endDate === null
      ) {
        this.filterQuery.filterNoDueDate = true;
        this.filterQuery.filterByDate = false;
      } else {
        this.filterQuery.filterByDate = true;
        this.filterQuery.filterNoDueDate = false;
      }
      this.focusFilterBtn();
    },
    onUpdateDateCreated() {
      this.filterQuery.filterByDateCreated = true;
      this.focusFilterBtn();
    },
    onUpdateDateCompleted() {
      this.filterQuery.filterByDateCompleted = true;
      this.focusFilterBtn();
    },
    setSort(sortType) {
      this.filterQuery.sort = sortType;
    },
    setPriority() {
      let priority = $(
        ".filter-rating .vue-star-rate ul.list li.active"
      ).length;
      this.filterQuery.priorityFilter = priority;
    },
    onWhoSearch(input) {
      this.isContactsLoading = true;
      if (typeof window.DUP_LIT !== "undefined") {
        clearTimeout(window.DUP_LIT);
      }
      window.DUP_LIT = setTimeout(() => {
        input = input == false ? "" : input;
        axios
          .get(
            process.env.MIX_API_BASE_URL +
              "activeContacts?q=" +
              encodeURI(input)
          )
          .then((resp) => {
            this.isContactsLoading = false;
            this.contacts = [];
            for (let x = 0; x < resp.data.length; x++) {
              resp.data[x]["name"] =
                resp.data[x]["first_name"] + " " + resp.data[x]["last_name"];
              this.contacts.push(resp.data[x]);
            }
          })
          .catch(() => {
            this.isContactsLoading = false;
          });
      }, 500);
    },
    onTagSearch(input) {
      this.isTagsLoading = true;
      if (typeof window.DUP_LIT1 !== "undefined") {
        clearTimeout(window.DUP_LIT1);
      }
      window.DUP_LIT1 = setTimeout(() => {
        input = input == false ? "" : input;
        axios
          .get(process.env.MIX_API_BASE_URL + "tags?q=" + encodeURI(input))
          .then((resp) => {
            this.isTagsLoading = false;
            this.tags = [];
            for (let x = 0; x < resp.data.length; x++) {
              this.tags.push(resp.data[x]);
            }
          })
          .catch(() => {
            this.isTagsLoading = false;
          });
      }, 500);
    },
    onDepartmentSearch(input) {
      this.isDepartmentsLoading = true;
      if (typeof window.DUP_LIT2 !== "undefined") {
        clearTimeout(window.DUP_LIT2);
      }
      window.DUP_LIT2 = setTimeout(() => {
        input = input == false ? "" : input;
        axios
          .get(
            process.env.MIX_API_BASE_URL +
              "activeDepartments?q=" +
              encodeURI(input)
          )
          .then((resp) => {
            this.isDepartmentsLoading = false;
            this.departments = [];
            for (let x = 0; x < resp.data.length; x++) {
              this.departments.push(resp.data[x]);
            }
          })
          .catch(() => {
            this.isDepartmentsLoading = false;
          });
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.dup-selected-count {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
}

.dup-action-link {
  font-size: 13px;
  white-space: nowrap;
}
</style>

<style lang="scss">
#deliverable__in__project__list__dup .deliverable-block:last-child {
  margin-bottom: 0 !important;
}
.duplicate-step2{
  i{
    vertical-align: middle;
  }
  .header-controls{
    padding: 10px 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin: 0 0 30px 0;
    .row{
      display: flex;
      align-items: center;
    }
    .container-fluid{
      padding-left: 50px!important;
      padding-right: 50px!important;
    }
  }
  .select-btn{
    // background-color: var(--wizard-next-bg);
    // border-color: var(--wizard-next-border);
    // color: #fff;
    border-radius: 0.55rem;
    font-weight: 500;
    min-width: 76px;
  }

  .custom-control-label{
    font-weight: bold;
    line-height: 22px;
    cursor: pointer;
    user-select: none;
  }
  .custom-control-input{
    user-select: none;
    cursor: pointer;
  }
  .filters-form{
    padding: 0;
  }
  .media-calls-search{
    border-radius: .7rem!important;
    font-size: 13px;
    color: #000;
    font-weight: 600;
    &::placeholder{
      font-size: 13px;
      color: #000;
      font-weight: 600;
    }
  }
}
</style>
